(window as any).environment = {
  production: true,
};
